import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AccountUserService } from '../service/account.service';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class LeadService {

    appUrl = "";
    localAppUrl = "";
    appCore = "";
    apiUrlLead = "";
    contactUrl = "";
    apiUrlAccount = '';
    user;
    apiUrlLogin = "";
    appOrgUrl = '';
    leadApiNew = '';
    leadApiV2 = '';
    taskStatusUpdate = new BehaviorSubject({});

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
        this.accountUserService.user.subscribe(x => this.user = x);
        // this.appUrl = environment.apiUrl + "Lead/";
        this.appUrl = environment.apiUrlNew + "Lead/";
        this.apiUrlLogin = environment.apiUrlLogin;
        this.localAppUrl = environment.localApiUrl;
        this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
        this.apiUrlLead = environment.apiUrlLead + 'API/';
        this.contactUrl = environment.contactAPI + '/LionO360/2.0/API/';
        this.apiUrlAccount = environment.apiUrlAccount;
        this.appOrgUrl = environment.appOrgUrl;
        this.leadApiNew = environment.apiUrlNew;
        this.leadApiV2 = environment.apiUrlNewLead + 'v2/Lead/';
    }




    getAllStages(companyID: number) {
        return this.http.get<any>(environment.apiUrlLead + 'LeadAPI/LeadStage', {
            params: new HttpParams().append("organizationId", companyID.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllCountries() {
        return this.http.get<any>(this.appCore + 'Country')
            .toPromise()
            .then(res => res);
    }

    getAllCities(stateId: number) {
        return this.http.get<any>(this.appCore + 'City', {
            params: new HttpParams().append("stateId", stateId.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllAsyncCities(stateId: number) {
        return this.http.get<any>(this.appCore + 'City', {
            params: new HttpParams().append("stateId", stateId.toString())
        })
            .toPromise();
    }

    getAllStates(countryId: number) {
        return this.http.get<any>(this.appCore + 'State', {
            params: new HttpParams().append("countryId", countryId.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllAsyncStates(countryId: number) {
        return this.http.get<any>(this.appCore + 'State', {
            params: new HttpParams().append("countryId", countryId.toString())
        })
            .toPromise();
    }

    getAllSalutations() {
        return this.http.get<any>(this.contactUrl + 'Salutation')
            .toPromise()
            .then(res => res);
    }

    getAllIndustries() {
        return this.http.get<any>(this.appCore + 'Industry')
            .toPromise()
            .then(res => res);
    }

    getAllTargets() {
        return this.http.get<any>(this.appCore + 'TargetList')
            .toPromise()
            .then(res => res);
    }

    getAllLeadStatus(groupId: number) {
        return this.http.get<any>(this.apiUrlLead + 'Status?groupId=' + groupId)
            .toPromise()
            .then(res => res);
    }

    getAllSocialProfiles(socialProfileType) {
        return this.http.get<any>(this.apiUrlAccount + 'Type?groupId=' + socialProfileType)
            .toPromise()
            .then(res => res);
    }

    getAllContactSocialProfiles() {
        return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/SocialProfile/SocialProfileType')
            .toPromise()
            .then(res => res);
    }

    getAllPhoneTypes(phoneType) {
        return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Phone/PhoneType')
            .toPromise()
            .then(res => res);
    }

    getAllContactPhoneTypes() {
        return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Phone/PhoneType')
            .toPromise()
            .then(res => res);
    }

    getAllEmailTypes() {
        return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType')
            .toPromise()
            .then(res => res);
    }

    // getAllContactEmailTypes(){
    //     return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType')
    //     .toPromise()
    //     .then(res => res);
    // }

    getAllLeadTypes(groupID: number) {
        return this.http.get<any>(this.apiUrlLead + 'Type?groupId=' + groupID)
            .toPromise()
            .then(res => res);
    }

    getAllEmployeesCount() {
        return this.http.get<any>(this.appCore + 'EmployeeCount')
            .toPromise()
            .then(res => res);
    }

    getAllRevenues() {
        return this.http.get<any>(this.appCore + 'AnnualRevenue')
            .toPromise()
            .then(res => res);
    }

    getAllSources(companyID: number) {
        return this.http.get<any>(this.appCore + 'Source', {
            params: new HttpParams().append("organizationId", companyID.toString())
        })
            .toPromise()
            .then(res => res);
    }


    getAllLeads(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, isActive?: boolean, searchValue?: string, seachFields?: string, stageId?, options?, typeId?, objectNamesList?) {
        if (isActive === undefined || isActive === null) {
            isActive = true;
        }

        let url = this.appUrl + "?organizationId=" + companyID + "&userId=" +
            userLoginID + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&isActive=" + isActive + '&isConvertedToAccount=false';

        if (stageId && stageId !== 0) {
            url = `${url}&stageId=${stageId}`;
        }

        if (typeId && typeId !== 0) {
            url = `${url}&typeId=${typeId}`;
        }

        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }

            if (options.moduleSearchValue) {
                url = `${url}&moduleSearchValue=${encodeURIComponent(options.moduleSearchValue)}`;
            }

            if (options.recentFilters) {
                url = `${url}&filters=${options.recentFilters}`;
            }
        }

        if (!options || !options.sort) {
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        if (!options || !options?.recentFilters) {
            url = `${url}&filters=allleads`;
        }

        if (searchValue) {
            url = `${url}&SearchValue=${encodeURIComponent(searchValue)}`;
        }

        if (searchValue && !options?.moduleSearchValue) {
            url = `${url}&SearchColumns=${seachFields}`;
        }

        if (objectNamesList && objectNamesList.length > 0) {
            objectNamesList.forEach(element => {
                url = `${url}&objectNameList=${element}`;
            });
        }

        return this.http.get<any>(url, {
            headers: new HttpHeaders({
                "organizationId": this.user.organizationId + '',
                "userId": this.user.userId + ''
            }),
            observe: 'response'
        })
            .toPromise()
            .then(res =>
            ({
                leads: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            })
            );
    }


    getLeadStageReasonComment(organizationId, userId, leadId, stageId) {
        let url = this.appUrl + 'GetStageReasonComment?organizationId=' + organizationId + '&leadId=' + leadId + '&stageId=' + stageId;
        return this.http.get<any>(url, {
            headers: new HttpHeaders({
                "userId": `${userId}`,
                "organizationId": `${organizationId}`
            })
        })
            .toPromise()
            .then(res => res);
    }

    getAllLeadsExport(companyID: number, userLoginID: number, objectNamesList?) {
        let url = this.appUrl + "Export?organizationId=" + companyID + "&userId=" + userLoginID;
        return this.http.get<any>(url)
            .toPromise()
            .then(res => res);
    }

    getLeadById(leadId, includeDeleted: boolean = false) {
        let params = new HttpParams();
        if(includeDeleted){
            params = params.append('includeDeleted', true);
        }
        let url = this.appUrl + leadId;
        return this.http.get<any>(url,{params}).toPromise();
    }

    getLeadDetailsById(leadId) {
        let url = this.appUrl + 'Details/' + +leadId;
        return this.http.get<any>(url).toPromise();
    }

    getLeadDetails(leadId) {
        return this.http.get<any>(this.appUrl + leadId)
            .toPromise()
            .then(res => res);
    }

    getLeadTaskDetails(leadTaskId) {
        return this.http.get<any>(environment.apiUrl + "Task/" + leadTaskId)
            .toPromise()
            .then(res => res);
    }

    getOrganizationDetails(organizationId) {
        return this.http.get<any>(environment.appOrgUrl + "Organization/" + organizationId)
            .toPromise()
            .then(res => res);
    }

    getLeadCount(organizationId, userId, recentFilters, typeId, PageNumber: Number, searchValue = '', seachFields = '', isLeadData = true, isActive) {
        let url = this.appUrl + "Count?organizationId=" + organizationId + '&typeId=' + typeId + '&isLeadData=' + isLeadData + '&groupId=0'
            + "&isActive=" + isActive;

        if (isLeadData) {
            url = url + '&PageSize=15&PageNumber=' + PageNumber + '&SortBy=CreatedDate&IsAscending=false'
        }

        if (recentFilters) {
            url = `${url}&filter=${recentFilters}`;
        }

        if (searchValue && isLeadData) {
            url = `${url}&SearchValue=${encodeURIComponent(searchValue)}&SearchColumns=${seachFields}`;
        }

        return this.http.get<any>(url, {
            headers: new HttpHeaders({
                "userId": `${userId}`,
                "organizationId": `${organizationId}`
            })
        })
            .toPromise()
            .then(res => res);
    }

    getKanbanLeadCount(organizationId, userId, PageNumber) {
        let url = this.appUrl + "Count?organizationId=" + organizationId + '&groupId=0&filter=allleads&typeId=1&PageNumber=' + PageNumber +
            '&PageSize=15&SortBy=CreatedDate&IsAscending=true&isLeadData=true&isActive=true';

        return this.http.get<any>(url, {
            headers: new HttpHeaders({
                "userId": `${userId}`,
                "organizationId": `${organizationId}`
            })
        })
            .toPromise()
            .then(res => res);
    }

    checkClearBitData(email) {
        return this.http.get<any>(environment.clearBitAPIURL + email, {
            headers: new HttpHeaders({
                "Authorization": environment.clearBitAPIKey
            })
        })
            .toPromise()
            .then(res => res)
    }

    addLead(leadData, organizationId) {
        return this.http.post<any>(this.appUrl, leadData)
    }

    updateLead(lead) {
        return this.http.put<any>(this.appUrl, lead, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    convertLeadToAccount(lead) {
        return this.http.post<any>(this.appUrl + "ConvertToAccount", lead)
            .toPromise()
            .then(res => res);
    }

    newConvertLeadToAccount(lead) {
        return this.http.post<any>(this.leadApiV2 + "ConvertToAccount", lead)
            .toPromise()
            .then(res => res);
    }

    assignUser(data) {
        return this.http.post<any>(this.appUrl + "Assign", data, {
            headers: new HttpHeaders({
                "UserSource": "192.192.19.0",
            })
        })
            .toPromise()
            .then(res => res);
    }

    updateLeadStage(leadStage) {
        let url = environment.apiUrlLead + "LeadAPI/Lead/Stage?id=" + leadStage.id + "&leadStageId=" + leadStage.leadStageId
        return this.http.put<any>(url, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    updateLeadStageWithComment(leadStage) {
        let url = environment.apiUrlLead + "LeadAPI/Lead/Stage?id=" + leadStage.objectRecordId + "&leadStageId=" + leadStage.stageId
        return this.http.put<any>(url, leadStage, {
            headers: this.headers
        });
    }

    getLeadContacts(leadId) {
        return this.http.get<any>(this.appUrl + 'Contact', {
            params: new HttpParams().append("leadId", leadId)
        })
            .toPromise()
            .then(res => res);
    }

    updateContact(c) {
        return this.http.put<any>(environment.apiUrl + 'Contact', c)
            .toPromise()
            .then(res => res);
    }

    addContact(c) {
        return this.http.post<any>(environment.contactURL + 'Contact', c)
            .toPromise()
            .then(res => res);
    }

    deleteContact(c) {
        return this.http.delete<any>(this.appUrl + 'Contacts/' + c.id)
            .toPromise()
            .then(res => res);
    }

    deleteLead(id) {
        return this.http.delete<any>(this.appUrl + id)
            .toPromise()
            .then(res => res);
    }

    updateTask(c) {
        return this.http.put<any>(this.appUrl + 'leadContacts/' + c.id, c)
            .toPromise()
            .then(res => res);
    }

    addTask(c) {
        return this.http.post<any>(environment.apiUrl + 'ObjectTask', c)
            .toPromise()
            .then(res => res);
    }

    deleteTask(c) {
        return this.http.delete<any>(this.appUrl + 'leadContacts/' + c.id)
            .toPromise()
            .then(res => res);
    }

    // getAllLeadPipelines() {
    //     return this.http.get<any>(this.localAppUrl + 'leadPipelines')
    //         .toPromise()
    //         .then(res => res);
    // }

    getLeadDashboardData() {
        return this.http.get<any>(this.localAppUrl + 'leadDashboard')
            .toPromise()
            .then(res => res);
    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    // updateUser(user) {
    //     return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
    //         .toPromise()
    //         .then(() => user);
    // }

    uploadLead({ OrganizationId, CreatedSource, UserId, file }) {
        const formData = new FormData();
        formData.append('filesData', file);
        const url = `${this.appUrl}import?organizationId=${OrganizationId}&CreatedSource=${CreatedSource}&UserId=${UserId}`;
        return this.http.post(url, formData, { responseType: 'text' }).toPromise();
    }

    getAllLeadsNameList(organizationId, loginUserId) {
        return this.http.get<any>(`${this.appUrl}LeadsWithName?isTerritory=false`, {
            headers: new HttpHeaders({
                "UserId": `${loginUserId}`,
                'OrganizationId': `${organizationId}`
            })
        })
    }

    getAllLeadsNameListByTerritory(organizationId, loginUserId, isTerritory, searchValue: string = "") {

        let url = `${this.appUrl}LeadsWithName?isTerritory=${isTerritory}`;

        if (searchValue) {
            url = url + `&search=${encodeURIComponent(searchValue)}`
        }


        return this.http.get<any>(url, {
            headers: new HttpHeaders({
                "UserId": `${loginUserId}`,
                'OrganizationId': `${organizationId}`
            })
        })
    }

    getLoggedUserDetails(userId: number) {
        return this.http.get<any>(environment.appOrgUrl + 'User/' + userId)
    }

    getQualifyReasons(groupId) {
        return this.http.get<any>(`${this.appCore}Category/GetAllCategoryOrganizationWise?groupId=` + groupId);
    }

    getQualifyDataByName(name) {
        return this.http.get<any>(`${this.apiUrlLead}Group/Name?name=` + name);
    }

    addQualifyReasons(data) {
        return this.http.post<any>(`${this.appCore}Category`, data);
    }

    updateQualifyReasons(data) {
        return this.http.put<any>(`${this.appCore}Category`, data);
    }

    deleteQualifyReasons(id) {
        return this.http.delete<any>(`${this.appCore}Category/${id}`);
    }

    getActiveInactiveDataByName(name) {
        return this.http.get<any>(`${this.apiUrlLead}Group/Name?name=` + name);
    }

    getActiveInactiveReasons(groupId) {
        return this.http.get<any>(`${this.appCore}Category/GetAllCategoryOrganizationWise?groupId=` + groupId);
    }

    addActiveInactiveReasons(data) {
        return this.http.post<any>(`${this.appCore}Category`, data);
    }

    updateActiveInactiveReasons(data) {
        return this.http.put<any>(`${this.appCore}Category`, data);
    }

    deleteActiveInactiveReasons(id) {
        return this.http.delete<any>(`${this.appCore}Category/${id}`);
    }

    getUserGroups(organizationId: number): Observable<any[]> {
        return this.http.get<any>(`${this.appOrgUrl}UserGroup?groupId=0`, {
            // return this.http.get<any>( `${environment.appOrgUrl}UserGroup?groupId=0`, {
            headers: new HttpHeaders({
                "organizationId": `${organizationId}`
            })
        });
    }

    getStatusCommentsForActiveInactive(id) {
        return this.http.get<any>(`${this.leadApiNew}Lead/StatusAudit?id=${id}`)
            .toPromise()
            .then(res => res);
    }

    activeInactiveLead(id, data) {
        let url = `${this.leadApiNew}Lead/ChangeActiveInactiveStatus/${id}`;
        return this.http.post(url, data)
            .toPromise()
            .then(res => res);
    }

}
